// Spiker matnlari TXT faylini sahifalarga ajratish (sof funksiya, so'rov yubormaydi).
//
// Format: har sahifa alohida qatordagi marker bilan boshlanadi — `=== N ===`.
// Bardoshli: kamida 3 ta "=" bilan boshlangan qator, ichidagi birinchi butun son — sahifa raqami
// (`===1===`, `=== 1-sahifa ===`, `=== Page 1 ===`, `=== Slayd 1 ===`, `=== Слайд 1 ===`, `=== 1`).

// Ekranda ko'rsatiladigan namuna (xato xabari va yordam matni). Testlar ham shundan foydalanadi.
export const FORMAT_SAMPLE = [
    '=== 1 ===',
    'Assalomu alaykum! Bugungi darsimizda ichki audit tushunchasi bilan tanishamiz.',
    "Matn bir necha qator yoki xatboshidan iborat bo'lishi mumkin.",
    '',
    '=== 2 ===',
    "Ikkinchi slaydda ichki auditning asosiy maqsadlarini ko'rib chiqamiz.",
    '',
    '=== 4 ===',
    "3-sahifa faylda yo'q — u bo'sh qoladi va foydalanuvchi uni qo'lda yozadi.",
].join('\n');

const MARKER_START = /^\s*={3,}/;

export const normalizeText = (text) =>
    String(text || '').replace(/^﻿/, '').replace(/\r\n?/g, '\n');

// Marker qatori bo'lsa sahifa raqami, "===" bilan boshlanib raqamsiz bo'lsa NaN, aks holda null
function readMarker(line) {
    if (!MARKER_START.test(line)) return null;
    const inner = line.trim().replace(/^=+/, '').replace(/=+$/, '');
    const match = inner.match(/\d+/);
    return match ? Number(match[0]) : NaN;
}

const isBlank = (line) => line.trim() === '';

function trimBlankLines(lines) {
    let start = 0;
    let end = lines.length;
    while (start < end && isBlank(lines[start])) start += 1;
    while (end > start && isBlank(lines[end - 1])) end -= 1;
    return lines.slice(start, end).join('\n');
}

// Natija: { pages: { [N]: matn }, markers: { [N]: qator }, errors: [{ line, message }], warnings: [...] }
// errors bo'sh bo'lmasa — fayl qabul qilinmaydi.
export function parseSpeakerNotes(rawText) {
    const lines = normalizeText(rawText).split('\n');
    const pages = {};
    const markers = {};
    const errors = [];
    const warnings = [];

    let current = null; // { page, line, body: [] }
    const preamble = [];

    const closeBlock = () => {
        if (!current || current.duplicate) return;
        const text = trimBlankLines(current.body);
        if (!text) {
            warnings.push({ line: current.line, message: `${current.page}-sahifa bloki bo'sh — e'tiborsiz qoldirildi.` });
        } else if (!(current.page in pages)) {
            pages[current.page] = text;
        }
    };

    lines.forEach((line, index) => {
        const lineNo = index + 1;
        const page = readMarker(line);

        if (page === null || Number.isNaN(page)) {
            if (Number.isNaN(page)) {
                warnings.push({ line: lineNo, message: `"===" bilan boshlanadi, lekin sahifa raqami yo'q — matn sifatida qoldirildi.` });
            }
            if (current) current.body.push(line);
            else preamble.push(line);
            return;
        }

        closeBlock();
        if (page in markers) {
            errors.push({ line: lineNo, message: `${page}-sahifa ikkinchi marta keldi (birinchisi ${markers[page]}-qatorda).` });
            current = { page, line: lineNo, body: [], duplicate: true };
            return;
        }
        markers[page] = lineNo;
        current = { page, line: lineNo, body: [] };
    });
    closeBlock();

    if (Object.keys(markers).length === 0) {
        return {
            pages: {},
            markers: {},
            errors: [{ line: null, message: "Faylda birorta ham sahifa markeri topilmadi. Har bir sahifa matni alohida qatordagi `=== N ===` bilan boshlanishi kerak." }],
            warnings: [],
            noMarkers: true,
        };
    }

    const preambleEnd = preamble.length;
    if (preamble.some((line) => !isBlank(line))) {
        warnings.unshift({ line: 1, message: `1–${preambleEnd}-qatorlar: birinchi markerdan oldingi matn e'tiborsiz qoldirildi.` });
    }

    return { pages, markers, errors, warnings };
}

// PDF'da yo'q sahifalar (0 yoki pageCount'dan katta) — ogohlantirish, sahifa e'tiborsiz qoldiriladi
export function rangeWarnings(parsed, pageCount) {
    if (!parsed) return [];
    return Object.keys(parsed.pages)
        .map(Number)
        .filter((page) => page < 1 || (pageCount && page > pageCount))
        .sort((a, b) => a - b)
        .map((page) => ({
            line: parsed.markers[page],
            message: page < 1
                ? `${page}-sahifa: raqam 1 dan boshlanadi — e'tiborsiz qoldiriladi.`
                : `${page}-sahifa PDF'da yo'q (PDF'da ${pageCount} sahifa) — e'tiborsiz qoldiriladi.`,
        }));
}

// PDF sahifalari doirasidagi sahifalar soni
export function countInRange(parsed, pageCount) {
    if (!parsed) return 0;
    return Object.keys(parsed.pages)
        .map(Number)
        .filter((page) => page >= 1 && (!pageCount || page <= pageCount)).length;
}
